module.exports = __webpack_public_path__ + "static/media/m1.c57ad69a.png";